<app-side-menu>
  <div class="b2b-ops-page">
    <div class="page-header">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div>
          <button type="button" class="btn-back" (click)="navigateBack()"><i class="fas fa-arrow-left"></i></button>
          <h1 class="page-title"><i class="fas fa-gavel me-2"></i>Multas</h1>
          <p class="page-subtitle" *ngIf="contractNumber">Contrato: {{ contractNumber }} — {{ contractName }}</p>
        </div>
        <app-button
          *appHasPermission="'B2BContracts.Edit'"
          text="Nova multa"
          color="var(--success-color)"
          height="40px"
          (buttonClick)="openCreate()">
          <i class="fas fa-plus me-2"></i>
        </app-button>
      </div>
    </div>

    <app-b2b-operational-nav *ngIf="contractId" [contractId]="contractId" active="multas"></app-b2b-operational-nav>

    <div class="b2b-ops-card">

      <div *ngIf="!isLoading && items.length === 0" class="b2b-ops-empty">
        <i class="fas fa-gavel"></i>
        <h3>Nenhuma multa cadastrada</h3>
      </div>

      <app-table
        *ngIf="isLoading || items.length > 0"
        [title]="'Multas (' + items.length + ')'"
        [data]="items"
        [columns]="columns"
        [actions]="actions"
        [loading]="isLoading"
        [showSearch]="true"
        (actionClick)="onActionClick($event)">
        <app-button
          table-header-action
          text="Exportar Excel"
          color="var(--success-color)"
          height="36px"
          [disabled]="items.length === 0"
          (buttonClick)="exportExcel()">
          <i class="fas fa-file-excel me-2"></i>
        </app-button>
      </app-table>
    </div>
  </div>

  <app-modal [isOpen]="showModal" [title]="modalTitle" size="lg" (close)="closeModal()">
    <form [formGroup]="form" class="b2b-ops-form-grid">
      <div class="form-group">
        <label class="form-label">AIT *</label>
        <input type="text" class="form-control" formControlName="aipNumber">
      </div>
      <div class="form-group">
        <label class="form-label">Tipo</label>
        <select class="form-select" formControlName="type">
          <option *ngFor="let t of typeOptions" [value]="t.value">{{ t.label }}</option>
        </select>
      </div>
      <div class="form-group">
        <app-b2b-contract-plate-select
          [contractId]="contractId"
          formControlName="vehiclePlate"
          (plateSelected)="onPlateSelected($event)">
        </app-b2b-contract-plate-select>
      </div>
      <div class="form-group">
        <label class="form-label">Status pagamento *</label>
        <select class="form-select" formControlName="paymentStatus">
          <option *ngFor="let s of paymentStatusOptions" [value]="s.value">{{ s.label }}</option>
        </select>
      </div>
      <div class="form-group">
        <label class="form-label">Emissão *</label>
        <input type="date" class="form-control" formControlName="issueDate">
      </div>
      <div class="form-group">
        <label class="form-label">Vencimento *</label>
        <input type="date" class="form-control" formControlName="dueDate">
      </div>
      <div class="form-group">
        <label class="form-label">Pago em</label>
        <input type="date" class="form-control" formControlName="paidDate">
      </div>
      <div class="form-group">
        <label class="form-label">Valor original *</label>
        <input type="number" class="form-control" formControlName="originalAmount" step="0.01">
      </div>
      <div class="form-group">
        <label class="form-label">Valor cobrado do cliente</label>
        <input type="number" class="form-control" formControlName="finalAmountToClient" step="0.01"
          placeholder="Com acréscimo (B2B/B2C)">
        <small class="text-muted">Se vazio, usa o valor original. É o valor da dash e do portal.</small>
      </div>
      <div class="form-group">
        <label class="form-label">Condutor</label>
        <input type="text" class="form-control" formControlName="driverName">
      </div>
      <div class="form-group">
        <label class="form-label">Data/hora infração</label>
        <input type="datetime-local" class="form-control" formControlName="infractionDateTime">
      </div>
      <div class="form-group">
        <label class="form-label">Local</label>
        <input type="text" class="form-control" formControlName="infractionLocation">
      </div>
      <div class="form-group">
        <label class="form-label">Cidade</label>
        <input type="text" class="form-control" formControlName="city">
      </div>
      <div class="form-group">
        <label class="form-label">UF</label>
        <input type="text" class="form-control" formControlName="state" maxlength="2" placeholder="SP">
      </div>
      <div class="form-group full">
        <label class="form-label">Descrição</label>
        <textarea class="form-control" rows="2" formControlName="description"></textarea>
      </div>
      <div class="form-group full">
        <label class="form-label">Observações</label>
        <textarea class="form-control" rows="2" formControlName="notes"></textarea>
      </div>
    </form>
    <div slot="footer" class="b2b-ops-modal-footer d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" (click)="closeModal()" [disabled]="submitting">
        {{ viewMode ? 'Fechar' : 'Cancelar' }}
      </button>
      <button *ngIf="!viewMode" type="button" class="btn btn-primary" (click)="submit()" [disabled]="submitting">
        {{ editingId ? 'Salvar' : 'Criar' }}
      </button>
    </div>
  </app-modal>
</app-side-menu>
